module.exports = __webpack_public_path__ + "img/button-s_billymorgan.a77a1db.png";